const employeeSummaryState = {
  employeeSummary: null,
  loading: false,
};

export const employeeSummaryReducer = (state = employeeSummaryState, action) => {
  switch (action.type) {
    case "GET_EMPLOYEE_SUMMARY":
      return {
        ...state,
        employeeSummary: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const advanceLoanSummaryState = {
  advanceLoanSummary: null,
  loading: false,
};

export const advanceLoanSummaryReducer = (state = advanceLoanSummaryState, action) => {
  switch (action.type) {
    case "GET_ADVANCE_LOAN_SUMMARY":
      return {
        ...state,
        advanceLoanSummary: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const attendancePatternsState = {
  attendancePatterns: null,
  loading: false,
};

export const attendancePatternsReducer = (state = attendancePatternsState, action) => {
  switch (action.type) {
    case "GET_ATTENDANCE_PATTERNS":
      return {
        ...state,
        attendancePatterns: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const topLeaveTakersState = {
  topLeaveTakers: null,
  loading: false,
};

export const topLeaveTakersReducer = (state = topLeaveTakersState, action) => {
  switch (action.type) {
     case "GET_TOP_LEAVE_TAKERS":
      return {
        ...state,
        topLeaveTakers: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const designationSalaryBreakdownState = {
  designationSalaryBreakdown: null,
  loading: false,
};

export const designationSalaryBreakdownReducer = (state = designationSalaryBreakdownState, action) => {
  switch (action.type) {
    case "GET_DESIGNATION_SALARY_BREAKDOWN":
      return {
        ...state,
        designationSalaryBreakdown: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};

const workforceMixState = {
  workforceMix: null,
  loading: false,
};

export const workforceMixReducer = (state = workforceMixState, action) => {
  switch (action.type) {
    case "GET_WORKFORCE_MIX":
      return {
        ...state,
        workforceMix: action.payload,
        loading: action.loader,
      };
    default:
      return state;
  }
};


